<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="100px"
          :model="form"
          :rules="rules"
        >
          <!-- 门店 -->
          <el-form-item label="门店" prop="branchId">
            <el-select
              v-model="form.branchId"
              placeholder="请选择门店"
              class="fix-width"
              clearable
              @change="branchChange"
            >
              <el-option
                v-for="item in branchList"
                :key="item.branchId"
                :label="item.title"
                :value="item.branchId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商户号" prop="mchId">
            <el-input v-model.trim="form.mchId" />
          </el-form-item>
          <el-form-item label="证书序列号" prop="serialNo">
            <el-input v-model.trim="form.serialNo" />
          </el-form-item>
          <el-form-item label="api密钥" prop="apiKey">
            <el-input v-model.trim="form.apiKey" show-password />
          </el-form-item>
          <el-form-item label="证书私钥" prop="privateKey">
            <el-input v-model.trim="form.privateKey" type="textarea" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getWePayConfig, setupWePay } from '@/api/settings'
import { getAllBranchs } from '@/api/branch'
export default {
  name: 'SettingsWechatMerchant',
  data() {
    return {
      labelPosition: 'right',
      branchList: [],
      form: {
        mchId: '',
        branchId:'',
        serialNo: '',
        apiKey: '',
        privateKey: '',
      },
      rules: {
        mchId: [],
        serialNo: [],
        apiKey: [],
        privateKey: [],
        branchId: [],
      },
    }
  },
  mounted() {
    this.getData()
    this.getAllBranchs()
  },
  methods: {
    //获取所有门店
    async getAllBranchs() {
      const res = await getAllBranchs({})
      if (!res) return
      this.branchList = res
    },
    async getData(branchId) {
      const ret = await getWePayConfig({
        name: 'merchant',
        branchId:branchId||''
      })
      this.form.mchId = ret&&ret.basic&&ret.basic.mchId
      // this.form.branchId = ret.basic.branchId
      this.form.serialNo = ret&&ret.basic&&ret.basic.serialNo
      this.form.apiKey = ret&&ret.basic&&ret.basic.apiKey
      this.form.privateKey = ret&&ret.basic&&ret.basic.privateKey
    },
    branchChange(branchId) {
      this.getData(branchId)
      this.form.branchId = branchId
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({},this.form)
          const branchId = form.branchId
          delete form.branchId
          await setupWePay({
            config: this.form,
            branchId
          })
          this.getData()
          this.$message.success('保存微信支付配置成功')
        } else {
          // this.$message.success('保存微信支付配置失败')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form-item__content {
    .el-rate {
      display: inline-block;
      font-size: 0;
      line-height: 1;
      vertical-align: middle;
    }

    .el-transfer__buttons {
      padding: 10px 10px 0 10px;
    }
  }
}
.title {
  color: #c3c3c3;
  padding-bottom: 10px;
  border-bottom: 1px solid #e3e3e3;
}
</style>
